import PageHeader from '@Guidelines/Layout/PageHeader';
import RolesContent from '@UI/Pages/Administration/Roles/RolesContent';
import RolesConfirmationDialogs from '@UI/Pages/Administration/Roles/ConfirmationDialogs/RolesConfirmationDialogs';
import RolesNotifications from '@UI/Pages/Administration/Roles/RolesNotifications';
import RoleSidebar from '@UI/Pages/Administration/Roles/Sidebars/RoleSidebar';
import { openRoleSidebar } from '@UI/Pages/Administration/Roles/Signals/roleSidebarSignal';
import { Plus } from 'lucide-react';
import * as React from 'react';
import { Button } from '@verclam/ui-kit';
import PageContainer from '@Guidelines/Layout/PageContainer';
import { css } from '@emotion/react';

const containerStyle = css`
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	flex: 1;
	overflow-y: auto;
`;

const RolesPage: React.FC = () => {
	const handleCreateClick = React.useCallback(() => {
		openRoleSidebar();
	}, []);

	const createButton = (
		<Button type="button" label="Nouveau rôle" icon={<Plus size={16} />} onClick={handleCreateClick} />
	);

	return (
		<PageContainer>
			<div css={containerStyle}>
				<PageHeader
					eyebrow="CONFIGURATION"
					title="Rôles & permissions"
					description="Gérez les rôles et les droits qu'ils accordent."
					actions={createButton}
				/>
				<RolesContent />
			</div>
			<RoleSidebar />
			<RolesConfirmationDialogs />
			<RolesNotifications />
		</PageContainer>
	);
};

export default RolesPage;
